import Notification from 'actions/notification';

export default Notification.createReducer();
